export const generateColorVariableName = (colorName: string) =>
  `--${colorName}-color`;
